import { createAsyncAction } from 'typesafe-actions';
import { ClaimantReportDto, ClaimantReportRequest } from '../dtos/claimantReportDto';

export const claimantReportActions = createAsyncAction(
  'GET_CLAIMANTS_FOR_REPORT_REQUEST',
  'GET_CLAIMANTS_FOR_REPORT_SUCCESS',
  'GET_CLAIMANTS_FOR_REPORT_ERROR',
)<ClaimantReportRequest, ClaimantReportDto[], string>();